export default __webpack_public_path__ + "static/media/Strugani 10.ed3a442c.jpg";